import React from 'react'

const VSpacer = ({ height = 12, ...props }) => (
  <div style={{ height }} {...props}></div>
)

export default VSpacer
